export default __webpack_public_path__ + "static/media/offerbanner.98cb0b47.png";